import { create } from "zustand";
import { statusModalStore } from "./statusModalStore";

export const useTimerStore = create((set, get) => ({
  timeLeft: 600,
  isRunning: false,
  intervalId: null,

  startTimer: (onFinishTimer) => {
    const { timeLeft, isRunning } = get();
    if (timeLeft > 0 && !isRunning) {
      const newIntervalId = setInterval(() => {
        set((state) => {
          if (state.timeLeft <= 1) {
            statusModalStore.getState().showModal({
              title: "El tiempo de tu reserva ha expirado",
              subtitle: "Debes reiniciar el proceso para completar tu reserva.",
              statusType: "warning", // o "warning" | "error"
              actionText: "Ok",
              action: () => onFinishTimer(),
            });

            return {
              timeLeft: 0,
              isRunning: false,
              intervalId: null,
            };
          }
          return { timeLeft: state.timeLeft - 1 };
        });
      }, 1000);
      set({ isRunning: true, intervalId: newIntervalId });
    }
  },

  stopTimer: () => {
    const { intervalId } = get();
    if (intervalId) {
      clearInterval(intervalId);
    }
    set({ isRunning: false, intervalId: null });
  },

  resetTimer: (newTime = 600) => {
    get().stopTimer();
    set({ timeLeft: newTime });
  },
}));
